import {
  DepartmentType,
  isDeliveryDepartmentType,
  isProductionDepartmentType,
  isWorkCentreEnabled,
  WorkCentreStatus,
} from 'helpers/production'
import {get} from 'lodash'

export const getJobCards = state => state.productionContext.jobBoards.jobCards.data || []

export const getJobCardsLoading = state => state.productionContext.jobBoards.jobCards.loading

export const getJobCardsCount = state => state.productionContext.jobBoards.jobCards.count || 0

export const getConfirmedOrders = state => state.productionContext.jobBoards.confirmedOrders.data || []

export const getConfirmedOrdersLoading = state => state.productionContext.jobBoards.confirmedOrders.loading

export const getConfirmedOrdersCount = state => state.productionContext.jobBoards.confirmedOrders.count || 0

export const getConfirmedOrdersPage = state => state.productionContext.jobBoards.confirmedOrders.page || 0

export const getJobBoardListViewSelector = state => state.productionContext.jobBoards.jobCardListView || []

export const getProductionDepartments = (state) => {
  const departments = state.departmentContext.departments || []
  return departments.filter(department => {
    const departmentType = get(department, 'departmentType', DepartmentType.PRODUCTION)
    return isProductionDepartmentType(departmentType)
  })
}

export const getProductionWorkCentres = (state) => {
  const workCentres = state.departmentContext.workCentres || []
  return workCentres.filter(workCentre => {
    const workCentreStatus = get(workCentre, 'workCentreStatus', WorkCentreStatus.ENABLED)
    const departmentType = get(workCentre, 'departmentType', DepartmentType.PRODUCTION)
    return isWorkCentreEnabled(workCentreStatus) && isProductionDepartmentType(departmentType)
  })
}

export const getDeliveryWorkCentres = (state) => {
  const workCentres = state.departmentContext.workCentres || []
  return workCentres.filter(workCentre => {
    const workCentreStatus = get(workCentre, 'workCentreStatus', WorkCentreStatus.ENABLED)
    const departmentType = get(workCentre, 'departmentType', DepartmentType.DELIVERY)
    return isWorkCentreEnabled(workCentreStatus) && isDeliveryDepartmentType(departmentType)
  })
}

export const getJobBoardFilters = state => state.productionContext.jobBoards.filters || {}

export const getJobBoardSetup = state => state.productionContext.jobBoards.jobBoardSetup

export const getExpandedWorkCentres = state => state.productionContext.jobBoards.expandedWorkCentres || []

export const isBulkRemoveFromJobBoardDialogVisible = state => state.productionContext.jobBoards.bulkRemoveFromJobBoardDialog.isVisible

export const isBulkRemoveFromJobBoardDialogBusy = state => state.productionContext.jobBoards.bulkRemoveFromJobBoardDialog.isBusy

export const getBulkRemoveFromJobBoardDialogAffectedOrders = state => state.productionContext.jobBoards.bulkRemoveFromJobBoardDialog.affectedOrders

export const isObserving = state => state.productionContext.jobBoards.jobCards.observing

export const isJobCardViewMaximised = state => state.productionContext.jobBoards.isJobCardViewMaximised || false
